import type { Booking, CommercialBillingScheduleBreakdownItem } from "../../../../../../types/bookings";
import type { PlanFieldItem } from "../../../../BookingForm/components/Commercial/add-plan";
import {
  buildHydratedCommercialPlans,
  createTurnoverRentOnlySeedPlan,
  resolveCommercialPlansSource,
} from "../../../../BookingForm/components/Commercial/add-plan";

export const getBookingPlans = (bookingDetails: Booking | undefined | null) => {
  if (bookingDetails?.commercialPaymentPlan?.length) return bookingDetails.commercialPaymentPlan;
  if (bookingDetails?.paymentPlan?.length) return bookingDetails.paymentPlan;
  return [];
};

export const buildPlansFromBookingDetails = (
  bookingDetails: Booking | undefined | null,
  isTurnoverRentOnly: boolean,
): PlanFieldItem[] => {
  const bookingPlans = getBookingPlans(bookingDetails);
  const breakdownData: CommercialBillingScheduleBreakdownItem[] =
    bookingDetails?.commercialBillingScheduleBreakdown ?? [];

  const plansSource = resolveCommercialPlansSource({ bookingPlans, breakdownData, isTurnoverRentOnly });

  if (plansSource.length > 0) {
    return buildHydratedCommercialPlans({
      plansSource,
      breakdownData,
      isTurnoverRentOnly,
      fallbackUnitAreaSqft: bookingDetails?.propertyDetails?.areaSqft,
    }) as PlanFieldItem[];
  }

  if (isTurnoverRentOnly) {
    return [createTurnoverRentOnlySeedPlan() as PlanFieldItem];
  }

  return [];
};
